module.exports = __webpack_public_path__ + "static/pocket-mobile-c481598a5c4c81e6e8682a75e0619963.png";